import { render, staticRenderFns } from "./TradeErrorTicket.vue?vue&type=template&id=b698c634&scoped=true&"
import script from "./TradeErrorTicket.vue?vue&type=script&lang=js&"
export * from "./TradeErrorTicket.vue?vue&type=script&lang=js&"
import style0 from "./TradeErrorTicket.vue?vue&type=style&index=0&id=b698c634&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b698c634",
  null
  
)

export default component.exports